import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'store/modules/base/redux';
import { translate } from 'store/modules/base/i18n';
import { disableSleepMode } from 'store/modules/settings';
import { Labels } from 'util/constants';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import useStyles from './style';
import utils from 'util/utils';
import withBoundary from 'component/ErrorBoundary/withBoundary';
import VWDigitalSignage from 'modules/Conference/components/DigitalSignage/VWDigitalSignage';

const SleepMode = (props) => {
  const intervalRef = useRef(null);
  const classes = useStyles();
  const {
    isExternalCallActive,
    isPrivacySleep,
    sleepHours,
    sleepMinutes,
    visible,
    showDigitalSignage,
    signageOptions
  } = props;
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  // eslint-disable-next-line no-unused-vars
  const [total, setTotal] = useState(0);

  useEffect(() => {
    if (sleepHours !== undefined && sleepMinutes !== undefined) {
      setTotal(sleepHours * 60 + sleepMinutes);
      setHours(sleepHours);
      setMinutes(sleepMinutes);
      if (intervalRef.current) clearInterval(intervalRef.current);
      intervalRef.current = setInterval(() => {
        updateHoursAndMinutes();
      }, 60000);
    }
    return () => clearInterval(intervalRef.current);
  }, [sleepHours, sleepMinutes]);
  function updateHoursAndMinutes() {
    setTotal((prev) => {
      let totalMinutes = prev - 1;
      if (totalMinutes > 0) {
        const h = utils.getHours(totalMinutes);
        const m = utils.getMinutes(totalMinutes);
        setHours(h);
        setMinutes(m);
      } else {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
        props.dispatch(disableSleepMode());
        if (props.onClosePress) {
          props.onClosePress();
        }
      }
      return totalMinutes;
    });
  }
  return (
    <Box
      className={classes.View}
      onClick={() => {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
        props.dispatch(disableSleepMode());
      }}>
      {showDigitalSignage ? (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0
          }}>
          <VWDigitalSignage
            options={{ ...signageOptions, signageStyle: 'replace' }}
            showLeave={false}
            url={signageOptions.sleepModeUrl}
          />
        </div>
      ) : (
        <Box className={classes.absoluteGrayView}>
          {visible && (
            <Box className={classes.text}>
              {`${
                isExternalCallActive
                  ? Labels.externalModeTextStart
                  : isPrivacySleep
                  ? Labels.privacyModeTextStart
                  : Labels.sleepModeTextStart
              }
              ${
                isExternalCallActive
                  ? ''
                  : `another ${utils.formatNumbers(
                      hours
                    )} hours ${utils.formatNumbers(minutes)} minutes`
              }`}
              {isExternalCallActive
                ? Labels.externalModeTextEnd
                : isPrivacySleep
                ? Labels.privacySleepModeTextEnd
                : Labels.sleepModeTextEnd}
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};

SleepMode.propTypes = {
  isExternalCallActive: PropTypes.bool,
  isPrivacySleep: PropTypes.bool,
  visible: PropTypes.bool,
  sleepHours: PropTypes.any,
  sleepMinutes: PropTypes.any,
  onClosePress: PropTypes.func,
  dispatch: PropTypes.func,
  showDigitalSignage: PropTypes.bool,
  signageOptions: PropTypes.object
};
/**
 * Function that maps parts of Redux state tree into component props.
 *
 * @param {Object} state - Redux state.
 * @returns {Object}
 */
function mapStateToProps(state) {
  const { sleepHours, sleepMinutes } = state['features/settings'];
  const userIdleMode = state['features/settings'].userIdleMode;
  const userDevice = state['features/login'].user?.device;

  return {
    sleepHours,
    sleepMinutes,
    visible: !(userIdleMode && userDevice?.options?.hideOtherText === 1),
    showDigitalSignage:
      userDevice?.showDigitalSignage &&
      userDevice?.digitalSignage?.showOnSleepMode,
    signageOptions: userDevice?.digitalSignage
  };
}

export default React.memo(
  translate(connect(mapStateToProps)(withBoundary(SleepMode)))
);
